export enum EnScheduleTypes {
  OpeningHours = 1,
  ClosingDays = 2,
  SpecialDays = 6,
}
